import MixpanelTracker from '../../mixpanelTracker';
import { CONTENT_LIBRARY } from '../../mixpanelConstants';

const mixpanelTracker = new MixpanelTracker();
export const MENU_ACTION = {
  VIDEO_INFO: 'Video Info',
  ADD_TO_CHANNEL: 'Add to Channel',
  EDIT_VIDEO: 'Edit Video',
  DOWNLOAD_REPORT: 'Download Report',
  DOWNLOAD_FILE: 'Download File',
  DELETE: 'Delete',
  SHARE: 'Share',
  RENAME: 'Rename',
  MANAGE_VIDEOS: 'Manage Videos'
};
export const CONTENT_TYPE = {
  VIDEO: 'Video'
};

function sendEvent(properties) {
  mixpanelTracker.setEventName(CONTENT_LIBRARY);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

export function trackVideoMenuAction(action, contentType = CONTENT_TYPE.VIDEO) {
  sendEvent({ Type: 'Menu Action', Action: action, 'Content Type': contentType });
}

export function trackVisitContentLibrary() {
  sendEvent({ Type: 'Visit' });
}

export function trackVideoUpload(contentType = CONTENT_TYPE.VIDEO) {
  sendEvent({ Type: 'Upload', 'Content Type': contentType });
}

export function trackVideoPlay(contentType = CONTENT_TYPE.VIDEO) {
  sendEvent({ Type: 'Play', 'Content Type': contentType });
}

export function trackManageButtonClick(action, contentType = CONTENT_TYPE.VIDEO) {
  sendEvent({ Type: 'Manage Button Click', Action: action, 'Content Type': contentType });
}

export function trackdeleteCheckBoxClick(contentType = CONTENT_TYPE.VIDEO) {
  sendEvent({ Type: 'CheckBox Click - checked', 'Content Type': contentType });
}

export function trackhandleSelectAllBtn(contentType = CONTENT_TYPE.VIDEO) {
  sendEvent({ Type: 'Select All', 'Content Type': contentType });
}

export function trackconfirmDeleteDialog(contentType = CONTENT_TYPE.VIDEO) {
  sendEvent({ Type: 'Confirm Delete Dialog', 'Content Type': contentType });
}

export function trackdeleteSelectedVideosBtn(contentType = CONTENT_TYPE.VIDEO) {
  sendEvent({ Type: 'Delete Selected Videos', 'Content Type': contentType });
}

// Track bulk delete API result
export function trackBulkDeleteResult(assetKeys, status, responseBody = {}) {
  const totalSelected = assetKeys.length;
  let totalSuccess = 0;
  let totalFailure = 0;

  if (status === 204) {
    // 204: All deletions successful
    totalSuccess = totalSelected;
  } else if (status === 400) {
    // 400: All deletions failed
    totalFailure = totalSelected;
  } else if (status === 200) {
    // 200: Partial success, use response fields
    totalSuccess = responseBody.totalSuccess || 0;
    totalFailure = responseBody.totalFailure || 0;
  }

  sendEvent({
    Type: 'Bulk Delete Result',
    'Total Selected': totalSelected,
    'Total Success': totalSuccess,
    'Total Failure': totalFailure,
    'Content Type': CONTENT_TYPE.VIDEO
  });
}
